// SportsProvider.jsx
import React, { createContext, useContext, useMemo, useReducer, useEffect } from "react";
import { AuthContext } from "../components/login/AuthContext"; // ajuste le path

const SportsCtx = createContext(null);

function normalizeCatalog(v) {
  console.log("normalizeCatalog called with:", v);
  const s = String(v || "").toLowerCase();
  if (s.startsWith("poke")) return "Pokemon";
  if (s.startsWith("hock")) return "Hockey";
  return null;
}

function reducer(state, action) {
  switch (action.type) {
    case "SET_SPORT":
      return { ...state, sport: action.sport };
    case "TOGGLE_SPORT":
      return { ...state, sport: state.sport === "Hockey" ? "Pokemon" : "Hockey" };
    default:
      return state;
  }
}

export function SportsProvider({ children, }) {
  const { preferredCatalog, setPreferredCatalog, userId, liveCsrfToken,loading } = useContext(AuthContext);

  // 1) Initial source: AuthContext pref -> localStorage -> prop initial -> Hockey
const storedActiveSport = normalizeCatalog(localStorage.getItem("activeSport"));
const authPref = normalizeCatalog(preferredCatalog);

const first =
  storedActiveSport 
console.log("SportsProvider initial sport:", { authPref, storedActiveSport, first });
  const [state, dispatch] = useReducer(reducer, { sport: first });

  // 2) Sync when Auth pref arrives/changes (ex: after checkAuth)
// useEffect(() => {
//   if (loading) return;

//   const pref = normalizeCatalog(preferredCatalog);

//   if (pref === "Hockey" || pref === "Pokemon") {
//     if (state.sport !== pref) {
//       dispatch({ type: "SET_SPORT", sport: pref });
//       localStorage.setItem("activeSport", pref);
//     }
//   }
// }, [preferredCatalog, loading, state.sport]);
  // 3) Unified setter: update provider + auth context + localStorage (DB later)
const setSport = async (s) => {
  const next = normalizeCatalog(s);
  dispatch({ type: "SET_SPORT", sport: next });
  localStorage.setItem("activeSport", next);
};

  const api = useMemo(() => ({
    state,
    setSport,
    toggle: () => setSport(state.sport === "Hockey" ? "Pokemon" : "Hockey"),
  }), [state.sport]); // important: dépendre juste de state.sport

  return <SportsCtx.Provider value={api}>{children}</SportsCtx.Provider>;
}

export function useSport() {
  const ctx = useContext(SportsCtx);
  if (!ctx) throw new Error("useSport() must be used inside <SportsProvider />");
  return ctx;
}
